export const POST_MESSAGES = {
  ADD_TO_CART: 'ExperienceAddToCart',
  BEST_MATCH: 'ExperienceBestMatch',
  DISPLAY_ROUTE: 'ExperienceDisplayRoute',
  DOM_HEIGHT: 'ExperienceDomHeight',
  HANDSHAKE: 'ExperienceApproveHandshake',
  HOST_CMS_EVENT: 'ExperienceHostCmsEvent',
  IFRAME_PARENT_DIMENSION: 'ExperienceIframeParentDimension',
  LAUNCHER_INITIAL_CLOSED: 'ExperienceLauncherInitialClosed',
  LOCALE: 'ExperienceLocale',
  NAVIGATE_WIDGET_IFRAME: 'ExperienceNavigateWidgetIframe',
  PAGE_SCROLL: 'ExperiencePageScroll',
  PRODUCT_CATEGORY: 'ExperienceProductCategory',
  PRODUCT_SETS: 'ExperienceProductSets',
  QUIZ_COMPLETED: 'ExperienceQuizCompleted',
  REQUEST_DOM_HEIGHT: 'ExperienceRequestDomHeight',
  REQUEST_HOST_HANDSHAKE: 'ExperienceRequestHostHandshake',
  REQUEST_INCLUDE_STYLES: 'ExperienceRequestIncludeStyles',
  SEND_TA_GA_EVENT: 'ExperienceTAGoogleAnalyticsEvent',
  SYNC_AUTH: 'ExperienceSyncAuth',
  SYNC_AUTH_CLEAR: 'ExperienceSyncAuthClear',
  VH_CLOSE_MODAL: 'ExperienceWidgetCloseModal',
  VH_HOST_LINK: 'ExperienceHostLink',
  VH_WIDGET_CLOSED: 'ExperienceWidgetClosed',
} as const;

export const WIDGET_IFRAME_MODES = {
  LAUNCHER_CLOSED: 'vh-launcher-closed',
  LAUNCHER_FOOTER_CLOSED: 'vh-launcher-footer-closed',
  LAUNCHER_FOOTER_OPENED: 'vh-launcher-footer-opened',
  LAUNCHER_LARGE_OPENED: 'vh-large-launcher-opened',
  LAUNCHER_OPENED: 'vh-launcher-opened',
  WIDGET: 'vh-widget',
} as const;

export const LAUNCHER_OPEN_REASON = {
  MANUAL: 'manual',
  SCROLL: 'scroll',
} as const;

export const PAGE_SCROLL = {
  START: 'scroll-start',
  STOP: 'scroll-stop',
} as const;

export const HOST_LINK_STORAGE_KEY = 'host-link';

export const HOST_CMS_EVENT_TYPES = {
  PRODUCT_VIEW: 'product_view',
  TRACKING_EVENT: 'tracking-event',
} as const;
